import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctDecimals, FctValue } from '../../../../Fct/generics';
import { FaGreaterThan } from 'react-icons/fa';
import { supportedContracts } from '../constants';
export var GreaterThan = createPlugin({
    protocol: 'TOKEN_VALIDATOR',
    type: 'VALIDATOR',
    method: 'greaterThan',
    description: 'Check if a amount1 is greater than amount2',
    supportedContracts: supportedContracts,
    getParams: function () { return ({
        input: {
            to: new FctAddress({}),
            methodParams: {
                valueToCheck: new FctValue({ destination: 'wei_amount', isPreview: true, icon: FaGreaterThan }),
                decimals1: new FctDecimals({}),
                threshold: new FctValue({ destination: 'wei_amount', isPreview: true }),
                decimals2: new FctDecimals({}),
                decimalsOut: new FctDecimals({}),
            },
        },
        output: {
            result: new FctValue({
                description: 'amount1 - amount2',
                innerIndex: 0,
            }),
        },
    }); },
});
